module.exports = __webpack_public_path__ + "img/journey.f5ef7937.svg";